export const LoyaltyRewardsMarkId = {
  ORBITZ_REWARDS_MARK_ID: 'loyalty',
  EPS_REWARDS_MARK_ID: 'rewards_orb',
  HAWAIIAN_REWARDS_MARK_ID: 'hawaiian'
};
export const EXPERIMENT = {
  PRESERVE_FILTERS_41276: 'Preserve_Activities_Filters'
};
// UitkHeadingTag only support till h6
export enum EgdsHeadingTagStyle {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
  H7 = 'h6',
  H8 = 'h6'
}
export enum TextTheme {
  INVERSE = 'inverse',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  PRIMARY = 'default',
  SECONDARY = 'default',
  LOYALTY = 'loyalty'
}
// ActivityBadgeTheme for image badges
export enum ActivityBadgeTheme {
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  DEAL_BUNDLED = 'DEAL_BUNDLED'
}
export const UITK_HEADING_SIZE = 5;
export const UITK_HEADING_SIZE_ACTIVITY = 7;
export const VERTICAL_LAYOUT_TRUE = 1;
export const VERTICAL_LAYOUT_FALSE = 3;
